import type { ReactNode } from 'react';

interface PageHeaderProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Free slot rendered below the title — typically stats, badges, or metadata. */
  meta?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ eyebrow, title, description, meta, actions }: PageHeaderProps) {
  return (
    <header className="flex flex-col gap-4 border-b border-jq-sand/60 pb-6 lg:flex-row lg:items-end lg:justify-between lg:gap-8">
      <div className="min-w-0 flex-1">
        {eyebrow ? <p className="jq-eyebrow jq-eyebrow--leader mb-3">{eyebrow}</p> : null}
        <h1 className="font-editorial text-[32px] font-medium leading-[1.1] tracking-tight text-jq-navy sm:text-[40px]">
          {title}
        </h1>
        {description ? (
          <p className="mt-3 max-w-xl text-[14px] leading-relaxed text-jq-graphite">
            {description}
          </p>
        ) : null}
        {meta ? <div className="mt-3">{meta}</div> : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2 lg:justify-end">{actions}</div>
      ) : null}
    </header>
  );
}
